interface Page404Props {
  children?: React.ReactNode
}
export default function Page404(props: Page404Props) {
  return <h1>404 URL NOT FOUND</h1>
}
